import { render, staticRenderFns } from "./MctTicks.vue?vue&type=template&id=565cfd16&"
import script from "./MctTicks.vue?vue&type=script&lang=js&"
export * from "./MctTicks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports